import { StyrtabellLanKommunDistriktDTO } from "~app/common/models/styrtabeller/StyrtabellLanKommunDistriktDTO";
import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IVerksamhetsomraden } from "~app/features/regelverk-viol/regelverk-viol.models";
import { StyrtabellRedovisningshanvisningIdHandelssortimentDto } from "../regelverkViol3.models";

export class AddOrUpdateRedovisningshanvisningStyrningCommand extends BasicCommand<AddOrUpdateRedovisningshanvisningStyrningCommand> {
    get primaryKey(): IPrimaryKey<AddOrUpdateRedovisningshanvisningStyrningCommand> {
        return {
            guid: this.guid
        };
    }
    id: number;
    guid: string;
    inmatningshandelssortiment: string;
    ersatt: boolean;
    befraktareId: number;
    mottagningsplatsId: number;
    anskaffningsform: string[];
    affarsform: string[];
    avverkningsform: string;
    transportslag: string;
    kontraktstyp: string;
    verksamhetsomraden: IVerksamhetsomraden[];
    lanKommunDistrikt: StyrtabellLanKommunDistriktDTO[];
    redovisningshanvisningar: StyrtabellRedovisningshanvisningIdHandelssortimentDto[];
    static readonly $groupKey = "Redovisningshanvisning";
    static readonly $type = "AddOrUpdateRedovisningshanvisningStyrningCommand";
    constructor(init: (instance: AddOrUpdateRedovisningshanvisningStyrningCommand) => void) {
        super(AddOrUpdateRedovisningshanvisningStyrningCommand.$type, AddOrUpdateRedovisningshanvisningStyrningCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
